import React, {PureComponent} from 'react'
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import Typography from '@material-ui/core/Typography';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

const styles = theme => ({
    root: {
        padding: 0,
        paddingTop: 2,
        backgroundColor: 'transparent',
    }

});


class ApplicationStepper extends PureComponent {
    state = {
        activeStep: 0,
        skipped: new Set(),
    };

    componentDidMount() {
        this.props.stepper && this.setState({
            activeStep: this.props.stepper.activeStep
        });
    }

    isStepOptional = step => false;

    handleNext = () => {
        const {activeStep} = this.state;
        let {skipped} = this.state;
        if (this.isStepSkipped(activeStep)) {
            skipped = new Set(skipped.values());
            skipped.delete(activeStep);
        }
        this.setState({
            activeStep: activeStep + 1,
            skipped,
        });
    };

    handleBack = () => {
        this.setState(state => ({
            activeStep: state.activeStep - 1,
        }));
    };

    handleSkip = () => {
        const {activeStep} = this.state;
        if (!this.isStepOptional(activeStep)) {
            // You probably want to guard against something like this,
            // it should never occur unless someone's actively trying to break something.
            throw new Error("You can't skip a step that isn't optional.");
        }

        this.setState(state => {
            const skipped = new Set(state.skipped.values());
            skipped.add(activeStep);
            return {
                activeStep: state.activeStep + 1,
                skipped,
            };
        });
    };

    handleReset = () => {
        this.setState({
            activeStep: 0,
        });
    };

    isStepSkipped(step) {
        return this.state.skipped.has(step);
    }

    getSteps = () => {
        let steps = this.props.stepper.steps
        const completedSteps = this.props.stepper.completedSteps

        for (let index in steps) {
            if (index < this.props.activeStep) {
                steps[index] = completedSteps[index]
            }
        }

        return steps;
    }

    render() {
        const {classes, children, toggle, activeStep} = this.props;
        const steps = this.getSteps();
        return (
            <Stepper activeStep={activeStep} className={classes.root}>
                {steps.map((label, index) => {
                    const props = {};
                    const labelProps = {};
                    if (this.isStepOptional(index)) {
                        labelProps.optional = <Typography variant="caption">Optional</Typography>;
                    }
                    if (label.indexOf('hylätty') !== -1) {
                        labelProps.error = true;
                    }
                    if (this.isStepSkipped(index)) {
                        props.completed = false;
                    }
                    return (
                        <Step key={label} {...props} onClick={this.handleNext}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        )
    }
}

ApplicationStepper.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ApplicationStepper);
